import Vue from "vue";
import Header from "../viewmodels/Header";
import { BaseApiRoutes, BaseApiGetters } from "@/modules/core/classes/Api";

// state
export const state = {
  header: {},
  activeTab: 0,
};

export const getters = {
  header: (state) => {
    return state.header;
  },
  activeTab: (state) => {
    return state.activeTab;
  },
};

// mutations
export const mutations = {
  update: (state, value) => {
    Vue.set(state, "header", new Header(value));
    return state.header;
  },
  reset: (state) => {
    Vue.set(state, "header", new Header());
    state.activeTab = 0;
    return state.header;
  },
  updateTab: (state, value) => {
    state.activeTab = value;
    return state.activeTab;
  },
};

// actions
export const actions = {
  update({ commit }, payload) {
    commit("update", payload);
  },
  reset({ commit }) {
    commit("reset");
  },
  updateTab({ commit }, payload) {
    commit("updateTab", payload);
  },
};
